<template>
  <div>
    <span v-if="!app.isTeacher()">See You Next Time!</span>
    <div v-else>
      <table>
        <caption>Session Report</caption>
        <tbody>
          <tr>
            <th>Student Name</th>
            <th>Away Time</th>
            <th>Absent Time</th>
            <th>Times Kicked</th>
            <th>Participation</th>
            <th>First Joined</th>
            <th>Last Left</th>
          </tr>
          <tr v-for="(report, index) in app.sessionReport" :key="index">
            <td>{{ report[0] }}</td>
            <td :class="{ 'text-red-500': report[1] > 60 * 1000, 'text-blue-500': report[1] > 0 && report[1] <= 60 * 1000 }">
              {{ formatTime(report[1]) }}
            </td>
            <td :class="{ 'text-red-500': report[2] > 60 * 1000, 'text-blue-500': report[2] > 0 && report[2] <= 60 * 1000 }">
              {{ formatTime(report[2]) }}
            </td>
            <td :class="{ 'text-red-500': report[3] > 0 }">
              {{ report[3] }}
            </td>
            <td :class="{ 'text-red-500': report[4] === 0 }">
              {{ report[4] }}
            </td>
            <td>
              {{ formatTimeStamp(report[5]) }}
            </td>
            <td>
              {{ formatTimeStamp(report[6]) }}
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <table>
        <caption>Recording Report</caption>
        <tbody>
          <tr>
            <th>Recording Started</th>
            <th>Recording Stopped</th>
          </tr>
          <tr v-for="(report, index) in app.recordingReport" :key="index">
            <td>
              {{ formatTimeStamp(report[0]) }}
            </td>
            <td>
              {{ formatTimeStamp(report[1]) }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="mx-auto mt-18">
        <a :href="`/${app.connection.name}?token=${app.connection.connection.token}`" class="underline text-blue-700">
          Rejoin This Room
        </a>
        <br />
        <span class="text-base">
          Note: The token you're using to join may be expired. If you have trouble using this link, please join with a new token.
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getApp } from '../models/App';

const app = getApp();

const formatTime = (timestamp: number) => {
  const date = new Date(timestamp);
  return `${date.getMinutes().toString().padStart(1, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
};

const formatTimeStamp = (timeStamp: number) => {
  const date = new Date(timeStamp);
  return date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', second: '2-digit' });
};
</script>

<style scoped>
div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 40px;
  font-weight: bold;
}

table {
  margin-top: 20px;
  border: 2px solid;
  border-collapse: collapse;
  padding: 10px;
  font-size: 26px;
}

th {
  border: 2px solid;
  border-collapse: collapse;
  padding: 10px;
  font-size: 26px;
}

td {
  border: 2px solid;
  border-collapse: collapse;
  padding: 10px;
  font-size: 18px;
  text-align: center;
}

caption {
  padding: 20px;
  font-size: 40px;
}

.red {
  color: red;
}

.blue {
  color: blue;
}
</style>
